import { ToggleGroup } from '@silo/ui';

export type ChartDateRange = 1 | 7 | 30;
type ChartDateRangeString = `${ChartDateRange}`;

export const isHourlyChartDateRange = (range: ChartDateRange) => range === 1;

const dateRangeToggles: { label: string; value: ChartDateRangeString }[] = [
  {
    label: '1D',
    value: `1`,
  },
  {
    label: '7D',
    value: `7`,
  },
  {
    label: '30D',
    value: `30`,
  },
];

type Props = {
  id: string;
  range: ChartDateRange;
  onChange: (range: ChartDateRange) => void;
};

export const ChartRangeToggle = (props: Props) => {
  return (
    <ToggleGroup
      id={props.id}
      toggles={dateRangeToggles}
      onChange={(value) => props.onChange(Number(value) as ChartDateRange)}
      value={`${props.range}`}
      label="Day range"
    />
  );
};
